export default __webpack_public_path__ + "static/media/markdown.e9c01e05.svg";